import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import {
    replaceHistoryState,
    hasAccess,
    StateType,
} from "client/utils"
import {
    mtAccountsRoute,
    mtAccountRoute,
} from "client/parts/routes"
import {
    PRM_ACCOUNT,
    StoreType,
    AccountProps,
    LoadAccountById,
    setAccountView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import MtPermissions from "client/pages/mt/permissions"

import Form from "./form"
import AssignedUsers from "../users/assigned"
import AssignedPackages from "../packages"


const DETAILS = "#details"
const USERS = "#users"
const PACKAGES = "#packages"
const PERMISSIONS = "#permissions"

const menu = [DETAILS, USERS, PACKAGES, PERMISSIONS]

const View = ({
    accountId = null,
    hash = null,
}: AccountProps) => {
    const account = useSelector((state: StoreType) => state.account.accountView)
    const reloadView = useSelector((state: StoreType) => state.account.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [activeTab, setActiveTab] = useState(menu.includes(hash) ? hash : DETAILS)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const targetAccountId = userData.accountId === 1 ? accountId : userData.accountId

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadAccountById(targetAccountId).then((res) => {
            dispatch(setAccountView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const handleMenuClick = (tab: string) => {
        setActiveTab(tab)
        if (userData.accountId === 1) {
            replaceHistoryState(`${mtAccountsRoute}/${VIEW}/${targetAccountId}${tab}`)
        } else {
            replaceHistoryState(`${mtAccountRoute}${tab}`)
        }
    }

    const viewAccess = hasAccess(PRM_ACCOUNT, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!account) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewAccount} # ${account.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageMenu>
                    <PageMenuButton
                        isActive={activeTab === DETAILS}
                        onClick={() => handleMenuClick(DETAILS)}
                    >
                        {lang.details}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === USERS}
                        onClick={() => handleMenuClick(USERS)}
                    >
                        {lang.users}
                    </PageMenuButton>
                    {
                        targetAccountId !== 1
                        && (
                            <PageMenuButton
                                isActive={activeTab === PACKAGES}
                                onClick={() => handleMenuClick(PACKAGES)}
                            >
                                {lang.packages}
                            </PageMenuButton>
                        )
                    }
                    {
                        targetAccountId !== 1
                        && userData.accountId === 1
                        && (
                            <PageMenuButton
                                isActive={activeTab === PERMISSIONS}
                                onClick={() => handleMenuClick(PERMISSIONS)}
                            >
                                {lang.permissions}
                            </PageMenuButton>
                        )
                    }
                </PageMenu>
                <Tab show={activeTab === DETAILS}>
                    {loadState === PENDING && <Loader />}
                    <Form />
                </Tab>
                <Tab show={activeTab === USERS}>
                    <AssignedUsers accountId={targetAccountId} />
                </Tab>
                {
                    targetAccountId !== 1
                    && (
                        <Tab show={activeTab === PACKAGES}>
                            <AssignedPackages accountId={targetAccountId} />
                        </Tab>
                    )
                }
                {
                    targetAccountId !== 1
                    && userData.accountId === 1
                    && (
                        <Tab show={activeTab === PERMISSIONS}>
                            <MtPermissions accountId={targetAccountId} />
                        </Tab>
                    )
                }
            </PageContent>
        </Container>
    )
}
export default View
